import { t } from 'i18next'

import i18n from '@/lib/i18n'

export const PURCHASED_INFO_TITLE = i18n.t('top.menu.import')

export const PURCHASED_INFO_SUB_PAGE_TITLES = {
  purchasedInfoSalesDetail: t('purchasedInfo.subPage.title.salesDetail'),
  purchasedInfoBilledAmounts: t('purchasedInfo.subPage.title.billedAmounts'),
  purchasedInfoMakers: t('purchasedInfo.subPage.title.makers'),
  purchasedInfoMakersStores: t('purchasedInfo.subPage.title.makersStores'),
  purchasedInfoStores: t('purchasedInfo.subPage.title.stores'),
  purchasedInfoStoresSalesTypes: t(
    'purchasedInfo.subPage.title.storesSalesTypes'
  ),
  purchasedInfoStoresMakersSalesTypes: t(
    'purchasedInfo.subPage.title.storesMakersSalesTypes'
  ),
}
